import { render, staticRenderFns } from "./CreateEvacuationDiagramModal.vue?vue&type=template&id=24f1928f&"
import script from "./CreateEvacuationDiagramModal.vue?vue&type=script&lang=js&"
export * from "./CreateEvacuationDiagramModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports